export default __webpack_public_path__ + "static/media/CNo.57-2.82ad650a.jpg";